const ROUTE_PATH = {
  LOGIN: "/login",
  DASHBOARD: "/",
  SIGNUP: "/signup",
  FORGET_PASSWORD: "/forgot-password",
  FORGET_PASSWORD_CHECK_INBOX: "/check-inbox",
  FORGET_PASSWORD_LINK_EXPIRED: "/reset-link-expired",
  FORGET_PASSWORD_RESEND_LINK_FAILED: "/resend-link-failed",
  SIGNUP_REGISTRATION_REQUEST: "/registration-request",
  SIGNUP_REGISTRATIONS_EXISTS: "/registration-submitted",
  CREATE_PROFILE: "/create-profile",
  TERMS_AND_CONDITION: "/terms-and-conditions",
  PRIVACY_POLICY: "/privacy-policy",
  PRIVATE_DASHBOARD: "/dashboard",
  ORDER_MANAGEMENT: "/order-management",
  PAYMENTS: "/payments",
  TEST: "/test",
  CUSTOMER_SUPPORT:"/contact-us",
  CUSTOMER_SUPOORT_PUBLIC: "/customer-support",
  FAVOURITES:"/favourites",
  INVOICES:"/invoices",
  PAYMENT_SUCCESS:"/payment-success",
  INVENTORY_SETUP: "/inventory-setup",
  ADD_INVENTORY_PRODUCT_NEW: "/inventory-setup/add-product",
  EDIT_INVENTORY_PRODUCT: "/inventory-setup/edit-product/:id",
  DETAILS_INVENTORY_PRODUCT: "/inventory-setup/product-details/:id",
  SHOPIFY_SETUP: "/shopify-setup",
  CREATE_SHOPIFY_LIST: "/create-profile/shopify-list",
  EDIT_PROFILE: "/edit-profile",
  RESET_PASSWORD: "/reset-password/:uid/:token",
};

const API_PATH = {};

export { ROUTE_PATH, API_PATH };
